<div style="padding: 20px" id="family-ids-panel">
  <textarea #textArea type="text" (keyup)="setFamilyIds(textArea.value)" class="form-control" spellcheck="false">{{
    familyIds
  }}</textarea>
  <gpf-errors-alert [errors]="errors"></gpf-errors-alert>
</div>
